import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { Select } from '@panwds/react-ui';
import { useFilters } from '../../../hooks/useFilters/useFilters.esm.js';
import { actions } from '../../../state/actions.esm.js';
import '../../../state/reducer.esm.js';
import { AddButton } from './AddButton.esm.js';

var AddFilter = function (_a) {
    var normalizedFilterConfig = _a.normalizedFilterConfig, disabled = _a.disabled, isLoading = _a.isLoading, dataMetrics = _a.dataMetrics;
    var _b = useFilters(), displayedFilters = _b.displayedFilters, dispatch = _b.dispatch, name = _b.name;
    var items = useMemo(function () {
        return Object.values(normalizedFilterConfig).map(function (filter) { return ({
            children: filter.label,
            value: filter.name,
            disabled: filter.disabled || filter.static
        }); });
    }, [normalizedFilterConfig]);
    var getDefaultSelectedItems = function () {
        var defaultSelectedItems = items.filter(function (item) {
            return displayedFilters.includes(item.value);
        });
        return defaultSelectedItems.length > 0 ? defaultSelectedItems : [];
    };
    var _c = useState(getDefaultSelectedItems()), currentlySelectedItems = _c[0], setCurrentlySelectedItems = _c[1];
    useEffect(function () {
        setCurrentlySelectedItems(getDefaultSelectedItems());
    }, [displayedFilters]);
    var addFilter = useCallback(function (props) {
        var selectedItem = props.selectedItem, selectedItems = props.selectedItems, inputValue = props.inputValue;
        var selectedFilterName = selectedItem.value;
        var currentItems = selectedItems.map(function (item) { return item.value; });
        var index = currentItems.indexOf(selectedFilterName);
        var isNewlyAddedItem = index >= 0;
        var isSelectAll = !inputValue;
        if (isSelectAll) {
            var checked = selectedItem.checked;
            dispatch({
                type: checked ? actions.removeAllFilters : actions.displayAllFilters,
                payload: {
                    name: name
                }
            });
            setCurrentlySelectedItems(selectedItems);
        }
        else if (isNewlyAddedItem) {
            dispatch({
                type: actions.displayFilter,
                payload: {
                    name: name,
                    filterName: selectedFilterName
                }
            });
        }
        else {
            dispatch({
                type: actions.removeFilter,
                payload: {
                    name: name,
                    filterName: selectedFilterName
                }
            });
        }
    }, [name]);
    return (React.createElement(Select, { button: React.createElement(AddButton, { disabled: disabled, isLoading: isLoading, showLabel: !displayedFilters.length, dataMetrics: "".concat(dataMetrics) }), disabled: disabled || isLoading, items: items, selectedItem: currentlySelectedItems, onChange: addFilter, enableMultiSelect: true, enableSelectAll: true, enableSearch: true, dataMetrics: "".concat(dataMetrics, "-dropdown-add-remove") }));
};

export { AddFilter };
//# sourceMappingURL=AddFilter.esm.js.map
